
import React from "react";
import { PageLayout } from "@/components/layout/PageLayout";
import { FaqSection } from "@/components/services/cybersecurity/FaqSection";
import { HeroSection } from "@/components/services/advisory/HeroSection";
import { KeyChallengesSection } from "@/components/services/advisory/KeyChallengesSection";
import { ValuePropositionSection } from "@/components/services/advisory/ValuePropositionSection";
import { AdvisoryServicesSection } from "@/components/services/advisory/AdvisoryServicesSection";
import { ProcessJourneySection } from "@/components/services/advisory/ProcessJourneySection";
import { ValueMetricsSection } from "@/components/services/specializations/ValueMetricsSection";
import { SuccessStoriesSection } from "@/components/services/advisory/SuccessStoriesSection";
import { CallToActionSection } from "@/components/services/advisory/CallToActionSection";

const CybersecurityAdvisory = () => {
  const pageTitle = "Cybersecurity Advisory Services | edgefi";
  const pageDescription = "Transform security chaos into business growth with our strategic cybersecurity advisory services. Get expert guidance without the overwhelming complexity.";
  const pageUrl = window.location.origin + "/services/cybersecurity-advisory";
  
  return (
    <PageLayout
      title={pageTitle}
      description={pageDescription}
      canonicalUrl={pageUrl}
      keywords={["cybersecurity advisory", "virtual CISO", "security leadership", "GRC", "compliance", "risk management", "edgefi"]}
      schema={{
        type: "service",
        data: {
          name: "Cybersecurity Advisory Services",
          description: "Strategic cybersecurity advisory services to transform security chaos into business growth.",
          provider: {
            name: "edgefi",
            url: window.location.origin
          }
        }
      }}
    >
      {/* Hero Section */}
      <HeroSection />

      {/* Key Challenges Section */}
      <KeyChallengesSection />

      {/* Value Proposition Section */}
      <ValuePropositionSection />

      {/* Advisory Services Section */}
      <AdvisoryServicesSection />

      {/* Our Process Section */}
      <ProcessJourneySection />

      {/* Results Section */}
      <ValueMetricsSection 
        title="Real Business Outcomes"
        subtitle="Client Success Stories"
        description="Our clients achieve tangible business benefits that drive growth and competitive advantage."
        metrics={[
          {
            value: "6 weeks",
            label: "Time to First Results",
            description: "Clients typically see meaningful security improvements and business benefits in just 6 weeks."
          },
          {
            value: "68%",
            label: "Faster Deal Closures",
            description: "Clients close deals 68% faster when they can confidently demonstrate their security posture."
          },
          {
            value: "2.5x",
            label: "Security ROI",
            description: "Our strategic approach delivers 2.5x return on security investments through risk reduction and business enablement."
          },
          {
            value: "40%",
            label: "Compliance Cost Reduction",
            description: "Our unified compliance approach reduces the cost of maintaining multiple compliance frameworks by 40%."
          }
        ]}
      />

      {/* Success Stories Section */}
      <SuccessStoriesSection />
      
      {/* CTA Section */}
      <CallToActionSection />
      
      {/* FAQ Section */}
      <FaqSection />
    </PageLayout>
  );
};

export default CybersecurityAdvisory;
